import { DateTime } from 'luxon'

export const emailValidator = (email: string): boolean => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email)?.toLowerCase())
}

export function isValidCPF(cpf: string): boolean {
  if (typeof cpf !== 'string') return false
  cpf = cpf.replace(/[^\d]+/g, '')
  if (cpf.length !== 11 || !!cpf.match(/(\d)\1{10}/)) return false
  const cpfValid = cpf.split('')
  const validator = cpfValid
    ?.filter((digit, index, array) => index >= array?.length - 2 && digit)
    ?.map(el => +el)
  const toValidate = pop =>
    cpfValid
      ?.filter((digit, index, array) => index < array?.length - pop && digit)
      ?.map(el => +el)
  const rest = (count, pop) =>
    ((toValidate(pop)?.reduce((soma, el, i) => soma + el * (count - i), 0) *
      10) %
      11) %
    10
  return !(rest(10, 2) !== validator[0] || rest(11, 1) !== validator[1])
}

export function isValidPhone(phoneNumber: string): boolean {
  if (!phoneNumber) return false

  const parsedPhoneNumber = phoneNumber.replace(/[()-\s]/g, '')
  const phoneNumberLengthWithDDD = 11

  return parsedPhoneNumber.length === phoneNumberLengthWithDDD
}

export const validatePhone = (phone: string): boolean => {
  if (phone) {
    const phoneNumbers = phone?.replace(/\D/g, '')
    return phoneNumbers[2] === '9' && phoneNumbers?.length === 11
  }
  return false
}

export function validateBirthDate(birthDate: string): boolean {
  if (!birthDate) return false

  const formattedBirthDate = DateTime?.fromFormat(birthDate, 'dd/MM/yyyy')
  const today = DateTime?.now()

  return formattedBirthDate?.startOf('day') < today?.startOf('day')
}

export function validateName(value: string): boolean {
  const nameArr = value?.split(' ')?.filter(item => item !== '')

  return nameArr?.length >= 2
}

export function validateEmail(email: string): boolean {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  return emailRegex?.test(email)
}

export function isCPFOrEmail(value: string): string {
  if (!value) return null
  if (isValidCPF(value)) return 'CPF'
  if (validateEmail(value)) return 'EMAIL'
}

export const validateLegalAge = (birthdate: string): boolean => {
  if (!birthdate) return false

  const formattedBirthdate = DateTime.fromFormat(birthdate, 'dd/MM/yyyy')
  if (!formattedBirthdate.isValid) return false

  const today = DateTime.now()
  const age = today.diff(formattedBirthdate, 'years').years
  return age >= 18
}
